import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function postPremios(params) {
  let response = {};
  await superagent
    .post(`${webservice}/postPremios`)
    .send(params)
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res?.body || {};
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
